import { Injectable, NgZone } from '@angular/core';
import { Observable, BehaviorSubject, empty } from 'rxjs';
import { SessionCookieService } from '@app/core/cookies';
import { FeedService, FeedDataResponse, FeedCard } from '@vestiaire/api-sdk-angular';
// import { feedApiFactory } from '../mocks/api.mock';
import { PlatformService } from '@app/shared/services/platform/platform.service';
const uniqBy = require('lodash/uniqBy');

@Injectable({
  providedIn: 'root'
})
export class FeedCardsService {
  private _cards$ = new BehaviorSubject<FeedCard[]>([]);
  private _hasNewerCards$ = new BehaviorSubject<number>(0);
  private _userId: string;
  private _next = '';
  private _TIMER_INTERVAL = 1 * 60 * 1000;
  private _interval = null;
  private _feedType: string;
  private _getNewCards = (userId: string): Observable<FeedDataResponse> => empty();
  private _getOldCards = (userId: string, next: string): Observable<FeedDataResponse> => empty();

  constructor(
    private feedService: FeedService,
    private sessionService: SessionCookieService,
    private platformService: PlatformService,
    private zone: NgZone
  ) {
    this._userId = this.sessionService.getUserId();
  }

  initCheckFeedStatus() {
    this.zone.runOutsideAngular(() => {
      this._interval = setInterval(() => {
        this.feedService.getUserFeedStatus(this._userId).subscribe(
          data => {
            if (data.data.total > 0) {
              this._hasNewerCards$.next(data.data.total);
            }
          },
          err => {
            console.log(err);
          }
        );
      }, this._TIMER_INTERVAL);
    });
  }

  killInterval() {
    clearInterval(this._interval);
  }

  get cards$() {
    return this._cards$.asObservable();
  }

  get hasNewerCards$() {
    return this._hasNewerCards$.asObservable();
  }

  get hasNewerCards(): number {
    return this._hasNewerCards$.getValue();
  }

  init(type?: 'suggested' | 'default' | 'mock_DONT_USE_IN_PROD') {
    if (type === 'suggested') {
      this._getNewCards = userId => this.feedService.getRecommendedUserFeed(userId);
      this._getOldCards = (userId, next) => this.feedService.getRecommendedUserFeed(userId, next);
    } else {
      this._getNewCards = userId => this.feedService.getUserFeed(userId);
      this._getOldCards = (userId, next) => this.feedService.getUserFeed(userId, next);
    }
    /*
    If mock needed */
    // if (type === 'mock_DONT_USE_IN_PROD') {
    //   this._getNewCards = () => feedApiFactory();
    //   this._getOldCards = () => feedApiFactory();
    // }

    this._feedType = type;
    this._cards$.next([]);
    this.fetchNewerCards();
    if (this.platformService.isBrowser) {
      this.initCheckFeedStatus();
    }
  }

  get feedType() {
    return this._feedType;
  }

  fetchOlderCards(cards = null) {
    this._getOldCards(this._userId, this._next).subscribe(
      data => {
        const currentCards = cards ? cards : this._cards$.getValue();
        // Order is important. Push front for most recent, push back for older ones.
        const allCards = currentCards.concat(data.data.orderedItems.filter(card => card !== null));
        this._next = data.data.next;
        this._cards$.next(uniqBy(allCards, 'id'));
      },
      err => {
        console.log(err);
      }
    );
  }

  fetchNewerCards(cards = null) {
    this._getNewCards(this._userId).subscribe(
      data => {
        const newCards = data.data.orderedItems;
        const currentCards = cards ? cards : this._cards$.getValue();
        // Order is important. Push front for most recent, push back for older ones.
        const allCards = newCards.concat(currentCards.filter(card => card !== null));
        this._next = data.data.next;
        this._cards$.next(uniqBy(allCards, 'id'));
        this._hasNewerCards$.next(0);
      },
      err => {
        console.log(err);
      }
    );
  }
}
